import { render, staticRenderFns } from "./InstantUser.vue?vue&type=template&id=bf1d2cde&scoped=true"
import script from "./InstantUser.vue?vue&type=script&lang=js"
export * from "./InstantUser.vue?vue&type=script&lang=js"
import style0 from "./InstantUser.vue?vue&type=style&index=0&id=bf1d2cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d2cde",
  null
  
)

export default component.exports